var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_25704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1293 44 44 34.1293 44 22C44 9.87069 34.1294 0 22 0C9.87057 0 0 9.87069 0 22C0 34.1293 9.87069 44 22 44ZM22 2.93328C32.516 2.93328 41.0667 11.4839 41.0667 22C41.0667 32.5161 32.5161 41.0667 22 41.0667C11.4839 41.0667 2.93328 32.5161 2.93328 22C2.93328 11.4839 11.484 2.93328 22 2.93328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4165 29.0075C28.6879 29.2275 29.0105 29.3302 29.3332 29.3302C29.7658 29.3302 30.1912 29.1396 30.4771 28.7802C30.9832 28.1495 30.8804 27.2255 30.2498 26.7195L23.4665 21.2928V10.2635C23.4665 9.45684 22.8065 8.79688 21.9998 8.79688C21.1932 8.79688 20.5332 9.45684 20.5332 10.2635V21.9969C20.5332 22.4443 20.7386 22.8622 21.0832 23.1408L28.4165 29.0075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_25704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.322939f8e5a0c6a0971ea4bfcb7f3171.svg";
export { ForwardRef as ReactComponent };